module.exports = __webpack_public_path__ + "media/images/front/right_arrow-694fa9c5b10763a362dd6c9a330295c8.svg";